/**
 * @author Matheus Vieira <matheus.vieira@deal.com.br>
 * @since 2020-11-16
 */
const basePath = process.env.REACT_APP_API;

export { basePath };
